// @flow

import type {ApplicationState} from '../../types'
import type {PlaceState} from '../types'

export function getPlaceCount(appState: ApplicationState): number{
  return _getPlaceCount(appState.place)
}

function _getPlaceCount(state: PlaceState): number{
  if (!state.pagination) return 0
  return state.pagination.count 
}

getPlaceCount.internal = _getPlaceCount
